import { Box } from "@mui/material"
import { gridClasses } from "@mui/x-data-grid-pro"
import type { GridRowSelectionModel, GridSortModel } from "@mui/x-data-grid-pro"
import type React from "react"
import { useMemo, useState } from "react"
import { extraColors } from "../../utils/theme"
import { BaseGrid } from "../BaseGrid/BaseGrid"
import { AlertCandidatesHeader } from "./AlertCandidatesHeader"
import { useAlertCuration } from "./AlertCurationContext"
import { AlertCurationFilters } from "./AlertCurationFilters"
import { getRowClassName, sharedGridSx } from "./AlertCurationShared"
import { useAlertCandidateColumns } from "./AlertCurationTableColumns/AlertCandidateColumns"

export const AlertCandidates: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <AlertCandidatesHeader />

      <AlertCurationFilters />

      <AlertCurationGrid />
    </Box>
  )
}

const AlertCurationGrid: React.FC = () => {
  const { isArchivedView, triage, centroidSignals, pinnedSignals, isLoading } =
    useAlertCuration()

  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "modern_score", sort: "desc" },
  ])

  const filteredCandidateSignals = useMemo(
    () => centroidSignals.filter(signal => !pinnedSignals.has(signal.id)),
    [centroidSignals, pinnedSignals]
  )

  const selectionModel = useMemo<GridRowSelectionModel>(
    () => ({
      type: "include",
      ids: new Set(pinnedSignals.keys()),
    }),
    [pinnedSignals]
  )

  const candidateColumns = useAlertCandidateColumns({
    isArchivedView,
    triage,
  })

  return (
    <BaseGrid
      loading={isLoading}
      rows={filteredCandidateSignals}
      columns={candidateColumns}
      checkbox={false}
      density="compact"
      treeData={false}
      exported={true}
      rowSelectionModel={selectionModel}
      sortModel={sortModel}
      onSortModelChange={setSortModel}
      sortingMode="client"
      pagination={false}
      getRowHeight={() => 58}
      getRowClassName={getRowClassName}
      sx={{
        ...sharedGridSx,
        [`& .${gridClasses.root} .${gridClasses.columnHeaders}`]: {
          background: extraColors.dark,
        },
        minHeight: "600px",
      }}
    />
  )
}
